export const userMessages = {
  Auth_AccountLocked: 'Uh oh, too many login attempts have failed. Wait 15 minutes and try again or reset your password.',
  Auth_InactiveUser: 'This user has been inactivated, sorry!',
  Auth_InvalidCredentials: "Hmm...that combo didn't work. Try again or reset your password.",
  Auth_InvalidInvite: "Oh no, looks like you don't have a valid invite! Please contact your pool service company for a new one.",
  Auth_InviteLoginExists: 'Good news! You already have a login. Try it out or reset your password.',
  Auth_InviteNotFound: "Aw dang! The invite you're using is no longer valid, please request a new one from your pool service provider.",
  Auth_LoginCreated: 'Success! Now sign in for pool service awesomeness!',
  Auth_LoginExistsForUser: 'You already have a login, please proceed to the Login page :)',
  Auth_NoCustomerAccess: "Sorry, this login doesn't have access to the requested customer",
  Auth_PasswordResetFailed: 'We were unable to reset your password. Please try again or contact your pool service provider.',
  Auth_PasswordChangeFailed: 'We were unable to change your password. Please try again.',
  Auth_UsernameInUse: 'This username is taken, please select another.',
  Incorrect_Current_Password: 'The current password you entered was incorrect.',
  Invalid_Password_Reset: 'Oh no, looks like your password reset link had an issue. Please request a new one.',
  ChangePassword_Success: 'Password updated successfully!',
  Customer_Not_Found: "This customer doesn't appear to be valid anymore :(",
  SignUp_Success: 'Success! Now sign in for pool service awesomeness!',
  Signup_User_Exists: 'Success! Now sign in for pool service awesomeness!',
  Unhandled_Error: "We're sorry, we couldn't complete your request. Please try again or contact your pool service provider.",
};

type messageKeyType = keyof typeof userMessages;

export function findMessage(key: string) {
  const messageKey = key as messageKeyType;
  return userMessages[messageKey];
}
